var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleLastIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64428 5.25586L4.44922 6.45092L8.33105 10.3412L4.44922 14.2315L5.64428 15.4266L10.7296 10.3412L5.64428 5.25586Z",
    fill: "#191E31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2302 5.25586L10.0352 6.45092L13.917 10.3412L10.0352 14.2315L11.2302 15.4266L16.3156 10.3412L11.2302 5.25586Z",
    fill: "#191E31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLastIcon);
export default __webpack_public_path__ + "static/media/doubleLastIcon.8936f5cbec43e9b3d3803706eaa6f937.svg";
export { ForwardRef as ReactComponent };